import type { Order } from '$lib/types/order';
import type { Position } from '$lib/types/position';
import { LARGE_NEGATIVE_INT, LARGE_POSITIVE_INT } from '$lib/web3/contants';
import BigNumber from 'bignumber.js';

export function getPositionFromOrder(e: Order) {
	let feesPaid = new BigNumber(e.keeperDeposit).plus(e.tradeFee).plus(e.commitDeposit).toString();
	let position: Position = {
		marketAddress: e.marketAddress,
		asset: e.asset,
		marketIdentifier: e.marketIdentifier,
		avgEntryPrice: '0',
		feesPaid: feesPaid,
		initialMargin: '',
		lastTxHash: '',
		margin: '',
		pnl: '',
		size: e.size,
		totalDeposits: '',
		totalVolume: e.size,
		trades: '',
		liquidationPrice: '',
		accruedFunding: '',
		takeProfit: '0',
		stopLoss: '0',
		tpslOrderId: '',
		noOfTpsl: 0
	};
	return position;
}

export function checkIfManuallyExecutable(orderTimestamp: string, minAgeForExecution: string) {
	return (parseInt(orderTimestamp) + parseInt(minAgeForExecution)) * 1000 < Date.now();
}

export function getTakeProfitAndStopLossFromOrder(order: Order, isLong: boolean) {
	let takeProfit = '0';
	let stopLoss = '0';
	const firstPairExists =
		new BigNumber(order.firstPairA).gt(0) && new BigNumber(order.firstPairB).gt(0);
	const secondPairExists =
		new BigNumber(order.secondPairA).gt(0) && new BigNumber(order.secondPairB).gt(0);

	if (isLong) {
		if (firstPairExists && secondPairExists) {
			takeProfit = order.firstPairA;
			stopLoss = order.secondPairB;
			return { takeProfit, stopLoss };
		}
		if (firstPairExists) {
			if (new BigNumber(order.firstPairA).eq(1)) {
				stopLoss = order.firstPairB;
				return { takeProfit, stopLoss };
			}
			takeProfit = order.firstPairA;
		}
		return { takeProfit, stopLoss };
	}
	if (firstPairExists && secondPairExists) {
		takeProfit = order.firstPairB;
		stopLoss = order.secondPairA;
		return { takeProfit, stopLoss };
	}
	if (firstPairExists) {
		if (new BigNumber(order.firstPairA).eq(1)) {
			takeProfit = order.firstPairB;
			return { takeProfit, stopLoss };
		}
		stopLoss = order.firstPairA;
	}
	return { takeProfit, stopLoss };
}

export function isOrderAndPositionInSameDirection(order: Order, position: Position) {
	return new BigNumber(order.size).isPositive() == new BigNumber(position.size).isPositive();
}

export function isOrderInProcess(order: Order) {
	return (
		order.orderType != 'Limit' &&
		order.status != 'Expired' &&
		order.status != 'FirstExecuted' &&
		order.status != 'Submitted'
	);
}

export function isValidTPSLOrderForPosition(order: Order, position: Position) {
	return (
		order.asset == position.asset &&
		order.status == 'FirstExecuted' &&
		((!order.totalFee && !isOrderAndPositionInSameDirection(order, position)) ||
			(order.totalFee && isOrderAndPositionInSameDirection(order, position)))
	);
}

export function isEntirePositionTPSLOrder(order: Order) {
	return (
		new BigNumber(order.size).lte(new BigNumber(LARGE_NEGATIVE_INT)) ||
		new BigNumber(order.size).gte(new BigNumber(LARGE_POSITIVE_INT))
	);
}

export function isItBedrockTime() {
	return false;
}

export function isItBedRockShutDownTime() {
	return false;
}

export function throwError() {
	throw {
		name: 'Bedrock upgrade downtime',
		message: '6th June 2023 16:00 UTC onwards there will be a downtime of 6 hours'
	};
}
